import { render, staticRenderFns } from "./GanttElastic.standalone.vue?vue&type=template&id=47914d89&"
import script from "./GanttElastic.standalone.vue?vue&type=script&lang=js&"
export * from "./GanttElastic.standalone.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/gantt-elastic/gantt-elastic/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('47914d89')) {
      api.createRecord('47914d89', component.options)
    } else {
      api.reload('47914d89', component.options)
    }
    module.hot.accept("./GanttElastic.standalone.vue?vue&type=template&id=47914d89&", function () {
      api.rerender('47914d89', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/GanttElastic.standalone.vue"
export default component.exports